module.exports = __webpack_public_path__ + "img/optmization.ed5d16ad.png";